import qs from 'qs'
import api from '../..'

export type Query = Record<string, any>

const adminApplicationsList = (q?: Query) => {
  return api
    .get(`administration/applications?${qs.stringify({ q })}`)
    .then(({ data: { data } }) => {
      return data.map(({ attributes }: any) => attributes)
    })
}

export default adminApplicationsList
